<template>
  <div class="s-my-application-container">
    <div class="s-my-application-list" v-if="myApplicationList.length > 0">
      <div
        class="s-my-application-item"
        v-for="(item, index) in myApplicationList"
        :key="index"
      >
        <div class="questions-title">产品详情：</div>
        <div class="product-info">
          <div class="product-info-row">
            <div>
              <span class="span-title">名称：</span>
              {{ item.name || '--' }}
            </div>
            <div>
              <span class="span-title">机构：</span>
              {{ item.institutionName || '--'}}
            </div>
            <div>
              <span class="span-title">贷款期限：</span>
              {{ item.deadline || '--' }}
            </div>
          </div>
          <div class="product-info-row">
            <div>
              <span class="span-title">贷款额度：</span>
              {{ item.lines || '--' }}
            </div>
            <div>
              <span class="span-title">担保类型：</span>
              {{ item.guaranteeTypeValue || '--' }}
            </div>
            <div>
              <span class="span-title">参考利率：</span>
              {{ item.rateStart || '--' }}%~{{ item.rateEnd || '--' }}%
            </div>
          </div>
        </div>
        <div class="s-deal-progress-wrap">
          <div class="questions-title">办理进度：</div>
          <ul class="flow">
            <li>
              <img
                src="../assets/image/financialInsurance/step1.png"
                class="img"
                alt
              />
              <p class="imgTitle">在线申请</p>
            </li>
            <li>
              <img
                src="../assets/image/financialInsurance/toRight.png"
                class="rightImg"
                alt
              />
            </li>
            <li>
              <img
                src="../assets/image/financialInsurance/step2.png"
                class="img"
                alt
              />
              <p class="imgTitle">银行审核</p>
            </li>
            <li>
              <img
                src="../assets/image/financialInsurance/toRight.png"
                class="rightImg"
                alt
              />
            </li>
            <li>
              <img
                src="../assets/image/financialInsurance/step3.png"
                class="img"
                alt
              />
              <p class="imgTitle">线上核实</p>
            </li>
            <li>
              <img
                src="../assets/image/financialInsurance/toRight.png"
                class="rightImg"
                alt
              />
            </li>
            <li>
              <img
                src="../assets/image/financialInsurance/step4.png"
                class="img"
                alt
              />
              <p class="imgTitle">在线授信</p>
            </li>
            <li>
              <img
                src="../assets/image/financialInsurance/toRight.png"
                class="rightImg"
                alt
              />
            </li>
            <li>
              <img
                src="../assets/image/financialInsurance/step5.png"
                class="img"
                alt
              />
              <p class="imgTitle">极速放贷</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="s-transaction-pagination" style="width: 100%">
        <el-pagination
            class="tab_pagination"
            background
            :page-size="pageSize"
            :current-page="currentPage"
            layout="prev, pager, next"
            @current-change="currentChange"
            :total="total"
        ></el-pagination>
      </div>
    </div>
    <div class="s-transaction-pagination" v-else>
      <el-empty description="暂无数据！" :image="noDataImg" :image-size="400"></el-empty>
    </div>
  </div>
</template>

<script>
import { getApplyLoanListPage } from "../utils/api/personalCenter";
export default {
  name: "my-application",
  data() {
    return {
      myApplicationList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      noDataImg:require('../assets/image/pest/no-data.jpg')
    };
  },
  mounted() {
    this.getApplyLoanListPage();
  },
  methods: {
    async getApplyLoanListPage() {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      let res = await getApplyLoanListPage(params);
      console.log("res", res);
      if (res.data.code == 0) {
        this.myApplicationList = res.data.data.records;
        this.total = res.data.data.total;
      } else {
        this.$message.warning(res.data.msg);
      }
    },
    currentChange(value) {
      this.currentPage = value;
      this.getApplyLoanListPage();
    },
    //更改pageSize
    pageSizeChange(value) {
      this.pageSize = value;
      this.getApplyLoanListPage();
    },
  },
};
</script>

<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/personalCenter.scss";
</style>
